<template>
  <div class="card" @mouseover="showAddToCart = true" @mouseleave="showAddToCart = false">
    <div class="card__weapon">
      <span class="card__weapon-name">{{ getWeaponName(item.title) }}</span>
    </div>
    <div class="card__skin">
      <span class="card__skin-name">{{ getSkinName(item.title) }}</span>
    </div>
    <div class="card__exterior">
      <span v-if="getExteriorFromTitle(item.title)" class="card__exterior-name">{{ getExteriorFromTitle(item.title) }}</span>
    </div>
    <div class="card__preview">
      <!-- <img @click="goToSliderItem(item)" :src="imgDomain + item.img_url" class="img card__image" /> -->
      <img :src="imgDomain + item.img_url" class="img card__image"
        @click="openImagePreviewModal(imgDomain + item.img_url)" />
    </div>
    <div class="card__price">
      <span class="card__price-discount" v-if="hasOldPrice">
        <PricePair
          :fiat-amount="item.old_fiat_price || item.old_price"
          :internal-amount="item.internal_old_price"
          layout="inline"
        />
      </span>
      <PricePair :item="item" layout="inline" />
    </div>
    <div class="card__action-wrapper" v-show="showAddToCart" @click="handleAddToCart(item, item.id)">
      <img src="./../assets/cart.svg" class="img card__add-to-cart-icon" />
      <span>{{ $t('Add to cart') }}</span>
    </div>
  </div>
</template>

<script>
import { getExteriorFromTitle, getWeaponName, getSkinName } from '../../src/utils/helpers';
import PricePair from './prices/PricePair.vue';

export default {
  name: 'ProductCard',
  props: ['item', 'addToCartChosenItem', 'sliderIsClickble', 'tag', 'currency', 'openImagePreviewModal'],
  components: {
    PricePair
  },
  data: function () {
    return {
      imgDomain: '',
      showAddToCart: false
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN
  },
  computed: {
    hasOldPrice() {
      const oldFiatPrice = Number(this.item.old_fiat_price || this.item.old_price || 0)
      const fiatPrice = Number(this.item.fiat_price || this.item.price || 0)
      const oldInternalPrice = Number(this.item.internal_old_price || 0)
      const internalPrice = Number(this.item.internal_price || 0)

      return oldFiatPrice > fiatPrice || oldInternalPrice > internalPrice
    }
  },
  methods: {
    getExteriorFromTitle,
    getWeaponName,
    getSkinName,
    handleAddToCart(item, id) {
      this.$store.dispatch('user/addToCart', { id, count: 1 })
        .then((message) => {
          this.$toast.success(message);
        })
        .catch((error) => {
          this.$toast.error(error);
        });
    },
    goToSliderItem(item) {
      let self = this
      setTimeout(() => {
        if (self.sliderIsClickble == true) {
          self.$emit('goToProduct', item)
        }
      }, 200)
    },
  }
}
</script>

<style scoped>
.card__price-discount {
  color: #777;
  display: inline-flex;
  position: relative;
}

.card__price-discount::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  border-top: 1px solid currentColor;
  pointer-events: none;
}
</style>
